module.exports = __webpack_public_path__ + "media/images/animations/number_of_tires/2-5e941bae99d6a6f43973ab47679fcd98.png";